import { RecommendedPrinterUpgradeRules } from 'src/types/featureFlags';

const recommendPrinter = (
  currentPrinter: string,
  currentPlan: number,
  recommmendedOptionsRules: RecommendedPrinterUpgradeRules[]
): string => {
  const match = recommmendedOptionsRules.find(
    (rule) =>
      // Checks if the rule matches the current printer and plan, or is a wildcard rule
      (rule.currentPrinter.toLowerCase() === currentPrinter.toLowerCase() &&
        rule.currentPlan === currentPlan) ||
      (rule.currentPrinter === '*' && rule.currentPlan === '*')
  );

  return match.recommendedPrinter;
};

export default recommendPrinter;
